import { render, staticRenderFns } from "./address-update.vue?vue&type=template&id=385acc27&scoped=true"
import script from "./address-update.vue?vue&type=script&lang=js"
export * from "./address-update.vue?vue&type=script&lang=js"
import style0 from "./address-update.vue?vue&type=style&index=0&id=385acc27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385acc27",
  null
  
)

export default component.exports